import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const { CancelToken } = axiosInstance;

export const getCustomerCompanyListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/GetCustomer`,
    method: 'get',
    params,
  });
};

let getSpotBidSearchResultsEffectCancelToken = () => {};
export const getSpotBidSearchResultsEffect = (data) => {
  getSpotBidSearchResultsEffectCancelToken();
  return axiosInstance.request({
    url: `${API.AUCTION}/GetSpotBidSearchResults`,
    method: 'post',
    data,
    cancelToken: new CancelToken(function executor(c) {
      getSpotBidSearchResultsEffectCancelToken = c;
    }),
  });
};

export const getShipmentProductDetailsEffect = (data) => {
  const shipmentKey = data?.shipmentKey;
  const key = data?.quoteKey ? 'quoteKey' : 'shipmentKey';
  const params = {
    [key]: shipmentKey,
  };
  return axiosInstance.request({
    url: `${API.AUCTION}${data?.quoteKey ? '/GetQuoteProductDetails' : '/GetShipmentProductDetails'}`,
    method: 'get',
    params,
  });
};

export const getShipmentDocumentListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/GetSpotQuoteDocuments`,
    method: 'get',
    params,
  });
};

export const quoteAuctionFileUploadEffect = (data) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/UploadQuoteAuctionDocument`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const getQuoteMultiStopEffect = (params) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/getQuoteMultiStop`,
    method: 'get',
    params,
  });
};

export const submitSpotBidEffect = (data) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/InsertSpotBid`,
    method: 'post',
    data,
  });
};

let getSpotBidFooterValuesCancelToken = () => {};
export const getSpotBidFooterValues = (data) => {
  getSpotBidFooterValuesCancelToken();
  return axiosInstance.request({
    url: `${API.AUCTION}/GetFooterContent`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getSpotBidFooterValuesCancelToken = c;
    }),
  });
};

let getShipperConsigneeResultsCancelToken = () => {};
export const getShipperConsigneeResults = (data) => {
  getShipperConsigneeResultsCancelToken();
  return axiosInstance.request({
    url: `${API.AUCTION}/GetShipperConsigneeSearch`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getShipperConsigneeResultsCancelToken = c;
    }),
  });
};

export const GetBidDeclineReasonEffect = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/bid-decline-reasons`,
    method: 'get',
  });
};

export const DeclineSpotBidEffect = (data) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/DeclineSpotBid`,
    method: 'post',
    params: data,
  });
};

export const generatePreviewEffect = (params) => {
  return axiosInstance.request({
    url: `${API.PDF_EXPORT}/GeneratePreview`,
    method: 'post',
    params,
  });
};

export const updateShipmentExpiryDurationEffect = (params) => {
  return axiosInstance.request({
    url: `${API.AUCTION}/UpdateShipmentExpiryDuration`,
    method: 'post',
    params,
  });
};
